export default {
    ja: {
        announcement: "※本イベントは終了しました。",
    },
    en: {
        announcement: "*This event has ended.",
    },
    zhCN: {
        announcement: "*本次活动已结束。",
    },
    zhTW: {
        announcement: "*本次活動已結束。",
    },
    ko: {
        announcement: "※본 이벤트는 종료되었습니다.",
    }

}